import type { AdvisorsPaths } from '@src/components/sco/Advisors/paths'

/** Directory query flag: only advisors who can take booked sessions. */
export const ACCEPTING_SESSIONS_QUERY_KEY = 'acceptingSessions'

export const parseAcceptingSessionsFilter = (value: unknown): boolean => {
  const raw = Array.isArray(value) ? value[0] : value
  return raw === true || raw === '1' || String(raw ?? '').toLowerCase() === 'true'
}

export const acceptingSessionsDirectoryHref = (
  paths: Pick<AdvisorsPaths, 'directory' | 'withQuery'>
): string => paths.withQuery(paths.directory, { [ACCEPTING_SESSIONS_QUERY_KEY]: '1' })
